export const convertTimeToClient = (time: string) => {
  if (!time) return { from: "00:00", to: "00:00" };

  const [from, to] = time.split("-");
  return { from, to };
};
